import { Directive, NgModule, ElementRef, Input, OnInit } from '@angular/core';
import { HttpService } from '../services/http.service';
@Directive({
    selector: '[appIsProfileimg]',
})
export class ProfileDirective implements OnInit {
    private el: any;
    private mbId: string;
    private http: any;

@Input('alt') set userId(value: string) { // {pick: 'powerLadder', tab: 'picks' }
    this.mbId = value;
    this.loadImage();
}
    constructor(el: ElementRef, http: HttpService) {
        this.el = el;
        this.http = http;
    }

    ngOnInit() {
        this.loadImage();
    }

    loadImage() {
        if (!this.mbId) {
            this.el.nativeElement.src = 'assets/images/common/no_profile.gif';
            return;
        }
        const imgSrc = '//www.chanceball.com/data/member/' + this.mbId.substr(0, 2) + '/' + this.mbId + '.gif';
        this.imageExists(imgSrc, (url: string) => {
            this.el.nativeElement.src = url;
        }, () => {
            this.el.nativeElement.src = 'assets/images/common/no_profile.gif';
            this.http.post({url: 'create-dummy-profile', params: {mb_id: this.mbId}});

        });

        // $.post('/lib/ajax.class.member.php?action=create-dummy-profile', {mb_id: ng_src}, function(){});
    }

    imageExists(url: string, success: any, failure: any) {
        const img = new Image();    // the
        let loaded = false,
        errored = false;

        // Run only once, when `loaded` is false. If `success` is a
        // function, it is called with `img` as the context.
        img.onload = () => {
            if (loaded) { return; }

            loaded = true;

            if (success && success.call) {
                success(url);
             }
        };

        // Run only once, when `errored` is false. If `failure` is a
        // function, it is called with `img` as the context.
        img.onerror = () => {
            if (errored) {return; }
            errored = true;

            if (failure && failure.call) { failure(img); }
        };

        // If `url` is in the `errors` object, trigger the `onerror`
        // callback.
        if (errored) {
            img.onerror.call(img);
            return;
        }

        // Set the img src to trigger loading
        img.src = url;

        // If the image is already complete (i.e. cached), trigger the
        // `onload` callback.
        if (img.complete) {
            img.onload.call(img);
        }
    }
}

@NgModule({
        declarations: [ ProfileDirective],
        exports: [ ProfileDirective]
})
export class ProfileDirectiveModule { // extends HammerGestureConfig

}
